import { createFileRoute } from "@tanstack/react-router";

import { InviteLinkCard } from "@/features/wonda/components/InviteLinkCard";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/invite",
)({
  component: InviteLinkCard,
});
